<template>
  <b-card no-body :border-variant="newsPost.variant">
    <router-link v-if="newsPost.image_url" :to="postLink">
      <picture>
        <source :srcset="darkImgUrl" media="(prefers-color-scheme: dark)" />
        <b-card-img :src="newsPost.image_url" top></b-card-img>
      </picture>
    </router-link>
    <b-card-body>
      <b-card-title>
        <router-link :to="postLink">
          {{ newsPost.title }}
        </router-link>
      </b-card-title>
      <b-card-sub-title class="mb-2 d-flex justify-content-between">
        <span v-if="showSection"
          >In
          <router-link
            :to="{
              name: 'PostsSection',
              params: { sectionSlug: newsPost.section_slug },
            }"
          >
            {{ newsPost.section_title }}
          </router-link>
        </span>
        <span>{{ formattedDate }}</span>
      </b-card-sub-title>
      <b-card-text v-html="parsedMarkdown"> </b-card-text>
      <router-link v-if="newsPost.summary" :to="postLink" class="card-link"
        >Read more</router-link
      >
    </b-card-body>
  </b-card>
</template>

<script>
import markdown from "@/mixins/markdown";
import dateFormat from "@/mixins/dateFormat";

export default {
  name: "NewsPost",
  mixins: [markdown, dateFormat],
  props: {
    newsPost: {
      type: Object,
      required: true,
    },
    showSection: {
      type: Boolean,
      required: false,
      default: false,
    },
  },
  computed: {
    postLink() {
      return { name: "SinglePost", params: { postSlug: this.newsPost.slug } };
    },
    formattedDate() {
      return this.formatDate(this.newsPost.created_on, "MMMM D, YYYY");
    },
    parsedMarkdown() {
      return this.parseMarkdown(this.newsPost.summary || this.newsPost.text);
    },
    darkImgUrl() {
      return this.newsPost.image_url.replace(/\.([^.]*)$/, "@dark.$1");
    },
  },
};
</script>

<style lang="less">
.card-text p:last-child {
  margin-bottom: 0;
}
</style>
